import {PaymentType} from './PaymentType';
export default PaymentType;